import { render, staticRenderFns } from "./defaultAd.vue?vue&type=template&id=2f596976&scoped=true&"
import script from "./defaultAd.vue?vue&type=script&lang=js&"
export * from "./defaultAd.vue?vue&type=script&lang=js&"
import style0 from "./defaultAd.vue?vue&type=style&index=0&id=2f596976&scoped=true&lang=css&"
import style1 from "./defaultAd.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f596976",
  null
  
)

export default component.exports